import React from 'react';
import MainLayout from '../../layouts/MainLayout';

export const Notifications = () => {
  return <MainLayout></MainLayout>;
};
